<script setup lang="ts">
import { ref, onBeforeMount } from "vue";
import { useApiClient } from "@/api/client";
import { useRouter } from "vue-router";
import DashboardDO = App.Data.DashboardDO;

const router = useRouter();

const headers = [
	{
		title: "Configuration",
		align: "start",
		key: "title",
		sortable: false,
	},
];

const isLoading = ref(true);
const items = ref();

onBeforeMount(() => fetchRecentStoredDocuments());

const fetchRecentStoredDocuments = async () => {
	isLoading.value = true;
	const response = await useApiClient("dashboard").index({
		page: 1,
		itemsPerPage: 4,
		sortBy: [{ key: "last_opened_at", order: "desc" }],
	});
	if (response.isOk()) {
		items.value = response.value.data;
	}
	isLoading.value = false;
};

const openConfiguration = (item: DashboardDO) => {
	router.push(`/dashboards/${item.uuid}`);
};
</script>

<template>
	<v-card class="d-flex flex-column">
		<v-card-title class="bg-background" style="height: 48px">
			Recent dashboards
		</v-card-title>

		<v-card-text class="px-2 py-0">
			<v-data-table
				density="compact"
				hide-default-header
				hide-default-footer
				:items="items"
				:headers="headers"
				:loading="isLoading"
			>
				<template #no-data>
					<div class="py-3">
						You don't have any dashboards. Click below to start making one
					</div>
				</template>
				<template v-slot:item.title="{ item }">
					<div
						class="d-flex align-items-center cursor-pointer"
						@click="openConfiguration(item)"
					>
						<div
							class="py-1"
							style="
								text-wrap: nowrap;
								max-width: 250px;
								overflow: hidden;
								text-overflow: ellipsis;
							"
						>
							{{ item.title }}
						</div>
						<v-spacer />
						<div>
							<v-btn
								v-tooltip="`Open dashboard ${item.title}`"
								color="on-surface"
								variant="text"
								density="compact"
								icon
							>
								<v-icon size="15"> fa: fal fa-arrow-right </v-icon>
							</v-btn>
						</div>
					</div>
				</template>
			</v-data-table>
			<v-divider opacity="0.25" />
		</v-card-text>

		<v-spacer />

		<div class="d-flex pa-2">
			<v-spacer />
			<v-chip variant="flat" to="/dashboards"> Go to dashboards </v-chip>
		</div>
	</v-card>
</template>

<style scoped lang="scss"></style>
